import { styled } from '@mui/material';
import { DesignTokens } from '../../specify';

export const TBRow = styled('tr')({
    boxSizing: 'border-box',
    '&:hover > th, &:hover > td': {
        backgroundColor: DesignTokens.color.neutralHoverGrey,
    },
});
